import {
    feedKnowledgeListPageRequest,
    feedKnowledgeItemRequest
} from "../../../actions/feed-actions"
import buildListContainer from "../../common/build-list-container"
import ModeratedKnowledgeListItem from "../../common/knowledge-list/ModeratedKnowledgeListItem"
import KnowledgeListItemShadow from "../../common/knowledge-list/KnowledgeListItemShadow"

export default buildListContainer(
    ModeratedKnowledgeListItem,
    KnowledgeListItemShadow,
    feedKnowledgeListPageRequest,
    feedKnowledgeItemRequest,
    "feed",
    "moderationFeed",
    "knowledge"
)
